import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        persistSession: true,
        detectSessionInUrl: true,
    },
});

/**
  @param {File} file
  @returns {Promise<string | null>}
 */

export const uploadProjectDemoVideo = async (file: File): Promise<string | null> => {
    try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) throw new Error("User not authenticated.");

        const fileExt = file.name.split(".").pop();
        const fileName = `video_${Date.now()}.${fileExt}`;
        const filePath = `${user.id}/videos/${fileName}`;

        const { data, error } = await supabase.storage
            .from("project_demos")
            .upload(filePath, file, { cacheControl: "3600", upsert: false });
        
        if (error) {
            return null;
        }
        return data.path;
    } catch (error) {
        return null;
    }
};

/**
 @param {File} file 
 @returns {Promise<string | null>} 
 */

export const uploadProjectThumbnail = async (file: File): Promise<string | null> => {
    try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) throw new Error("User not authenticated.");

        const fileExt = file.name.split(".").pop();
        const fileName = `thumbnail_${Date.now()}.${fileExt}`;
        const filePath = `${user.id}/thumbnails/${fileName}`;
        
        const { data, error } = await supabase.storage
            .from("project_demos")
            .upload(filePath, file, { cacheControl: "3600", upsert: false });

        if (error) {
            return null;
        }
        return data.path;
    } catch (error) {
        return null;
    }
};